import { render, staticRenderFns } from "./WidgetTasks.vue?vue&type=template&id=d45b14aa"
import script from "./WidgetTasks.vue?vue&type=script&lang=js"
export * from "./WidgetTasks.vue?vue&type=script&lang=js"
import style0 from "./WidgetTasks.vue?vue&type=style&index=0&id=d45b14aa&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports